module.exports = __webpack_public_path__ + "img/Steor-Icons-20.68dfb600.svg";